export default "/images/text-left.svg?6d599bfb46cfe6393b2527154604149d";